module.exports = __webpack_public_path__ + "bd73e2a3fb04f59d26efaf1605207f53.svg";